import React from 'react'
import Image from 'next/image'

import { icons } from '../assets'

export type IconProps = {
  rotate?: number
  className?: string
  style?: React.CSSProperties
  size?: number
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
}

type Props = IconProps & {
  name: keyof typeof icons
}

export const Icon: React.FC<Props> = ({ name, rotate, style, size = 16, ...restOf }) => {
  const iconStyle = React.useMemo(() => {
    return {
      ...style,
      transform: rotate ? `rotate(${rotate}deg)` : undefined,
    }
  }, [style, rotate, name])

  return <Image width={size} height={size} style={iconStyle} src={icons[name]} alt={name} {...restOf} />
}
